export default __webpack_public_path__ + "2cc5fa331481fb9d67860e77250bc51d.png";